














































































import { Component, Vue, Lifecycle, Mixin } from 'av-ts'
import { EventBus } from '@/eventbus'
import { VueUtils } from '@/mixins'
import { Language, ILesson, ITranslation, IUser } from '@/models'
import { StoreType } from '@/store'
import * as Utils from '@/utils'

type ILessonWithUser = ILesson & { user: IUser | null }

@Component({
  store: ['user', 'languages', 'lessons'],
})
export default class Lessons extends Mixin(EventBus, VueUtils) {
  $store!: StoreType
  loading = false
  createDialog = false

  addForm = {
    lessonName: '',
    srcLang: '',
    tgtLang: '',
  }

  lessonsVM = null as ILessonWithUser[] | null
  selectedLesson?: ILesson = undefined

  test(msg?: string) {
    console.debug(`*** TEST ${msg?msg:''} ***`)
    return false
  }

  @Lifecycle
  async created() {
    console.debug('Home.vue created')
    console.debug('  languages =', this.$store.languages)
    // console.debug('  languages=', this.languages)
    console.debug('  this.addForm =', this.addForm)
    this.addForm.srcLang = this.$store.languages[1].code
    this.addForm.tgtLang = this.$store.languages[0].code

    const usersMap = await this.$store.users

    if (this.$store.lessons) {
      this.lessonsVM = this.$store.lessons.map(lesson => {
        const user = usersMap ? usersMap.get(lesson.creator) || null : null
        return {...lesson, user }
      })
    }

    const testResults = await this.$store.getMyTestResults()
    if (testResults) {
      // get best score by lesson
    }
  }

  showCreateDialog() {
    this.createDialog = true
    this.$nextTick(() => this.setFocus(this.$refs.lessonNameTxtField))
  }

  async createLesson() {
    try {
      if (! this.addForm.srcLang || ! this.addForm.tgtLang)
        throw new Error('invalid form data')
      const lesson: ILesson = {
        _id: new Date().toJSON(),
        creator: this.$store.user!.email,
        name: this.addForm.lessonName,
        created: new Date().toJSON(),
        srcLang: this.addForm.srcLang,
        tgtLang: this.addForm.tgtLang,
        words: []
      }
      await this.$store.createLesson(lesson)
      this.emitNotif('Lesson successfully created !', {timeout: 2000})
      this.createDialog = false
    } catch (error) {
      EventBus.emitError('Lesson creation error: ' + error)
    }
  }

  async deleteLesson(lesson: ILesson) {
    try {
      const confirmed = await this.$confirm(`Are you sure wyou want to delete lesson "${lesson.name}" ?`)
      console.debug('[Home.vue] deleteLesson confirmed=', confirmed)
      if (confirmed)
        await this.$store.deleteLesson(lesson)
    } catch (error) {
      EventBus.emitError('Lesson deletion error: ' + error)
    }
  }

  lessonWords(lesson: ILesson) {
    this.$router.push({ name: 'lessonWords', params: { id: lesson._id } })
  }
  editLesson(lesson: ILesson) {
    this.$router.push({ name: 'lessonEdit', params: { id: lesson._id } })
  }
  testLesson(lesson: ILesson) {
    this.$router.push({ name: 'lessonTest', params: { id: lesson._id } })
  }

  exportLessonAsCSV(lesson: ILesson) {
    const filename = `lesson_${lesson.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.csv`
    const csvHeader = `${lesson.srcLang},${lesson.tgtLang}\n`
    const csvData = lesson.words.map(_ => `${_.srcWord},${_.tgtWord}`).join('\n')
    const link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const blob = new Blob([csvHeader+csvData],  { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  importIntoLesson(lesson: ILesson) {
    this.selectedLesson = lesson;
    (this.$refs.fileElem as HTMLElement).click()
  }

  async importCSVFiles(fileList: FileList) {
    if (! this.selectedLesson) return
    this.loading = true
    try {
      console.log('handleFiles', fileList)
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        console.log(`file[${i}] = `, file)
        try {
          const fileTxt = await Utils.readTextFile(file)
          const txt = fileTxt
          // const fileTxt = await Utils.readBinaryStringFile(file)
          // const txt = Utils.isUTF16LEWithoutBOM(fileTxt) ? Utils.decodeUTF16LE(fileTxt) : fileTxt
          console.log('text=', txt)
          const array = this.parseCSV(txt)
          if (array.length < 2) return EventBus.emitError('Nothing to import')
          // currently we do not check header (languages)
          // get order number : max order item in array + 1
          let order = this.selectedLesson.words.reduce((rslt, tsl) => Math.max(rslt, tsl.order), -1) + 1
          const words = 
            array.slice(1) // remove header
            .map(row => ({ _id: null, srcWord: row[0], tgtWord: row[1], order: order++} as ITranslation))
          // add words to selected lesson
          this.selectedLesson.words = this.selectedLesson.words.concat(words)
          // save lesson
          this.$store.saveLesson(this.selectedLesson)
        } catch (error) {
          EventBus.emitError(`Error reading file [${file}] : ${error}`)
        }
      }
    } finally {
      this.loading = false
      this.selectedLesson = undefined
    }
  }

  private parseCSV(csv: string, delimiter: string = ','): string[][] {
    const lines = csv.split('\n').filter(_ => _.trim().length > 0)
    return lines.map(line => line.split(delimiter))
  }

}
